var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 4.5,
    stroke: "#2D2D2D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.62663 7.33339C8.62645 7.68701 8.48581 8.02608 8.23563 8.276C7.98546 8.52593 7.64625 8.66623 7.29263 8.66606C6.93901 8.66588 6.59994 8.52523 6.35001 8.27506C6.10009 8.02489 5.95978 7.68568 5.95996 7.33206C5.96014 6.97843 6.10078 6.63937 6.35096 6.38944C6.60113 6.13952 6.94034 5.99921 7.29396 5.99939C7.64758 5.99957 7.98665 6.14021 8.23657 6.39039C8.4865 6.64056 8.6268 6.97977 8.62663 7.33339ZM8.66663 9.65339H5.99996V18.0001H8.66663V9.65339ZM12.88 9.65339H10.2266V18.0001H12.8533V13.6201C12.8533 11.1801 16.0333 10.9534 16.0333 13.6201V18.0001H18.6666V12.7134C18.6666 8.60006 13.96 8.75339 12.8533 10.7734L12.88 9.65339Z",
    fill: "#2D2D2D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.4ea77864bf6b51fe86b0c26d66b3ca23.svg";
export { ForwardRef as ReactComponent };